import { render, staticRenderFns } from "./CalculateWeight.vue?vue&type=template&id=b59f6a82"
import script from "./CalculateWeight.vue?vue&type=script&lang=js"
export * from "./CalculateWeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports